import { Mail, Phone, CalendarClock } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { QuoteButton } from "@/components/site/Nav";
import { RotatingLogo } from "@/components/site/RotatingLogo";
import { EMAIL, PHONE, PHONE_HREF } from "@/lib/api";

export const CTA = () => (
  <section className="bg-white px-3 pb-3 sm:px-6 sm:pb-6" data-testid="cta-section">
    <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#0B2A6F] px-6 py-20 text-white sm:px-12 lg:py-28 grain">
      <div className="grid-bg absolute inset-0" />
      <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-lime-400/25 blur-3xl" />
      <div className="absolute -bottom-32 left-10 h-80 w-80 rounded-full bg-emerald-400/20 blur-3xl" />
      <div className="relative grid items-center gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-8">
          <Eyebrow light>Ready when you are</Eyebrow>
          <h2 className="mt-5 max-w-4xl font-display text-5xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            Stop paying to get paid. <span className="text-lime-400">Keep it all.</span>
          </h2>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center">
            <QuoteButton testid="cta-quote-btn" className="!px-8 !py-4 text-base" />
            <a href="#book-call" data-testid="cta-book-call-link" className="inline-flex items-center gap-2 rounded-full border border-lime-300/60 px-6 py-4 text-sm font-bold text-lime-300 transition-colors hover:bg-lime-300 hover:text-[#050B1F]">
              <CalendarClock className="h-4 w-4" /> Book a call
            </a>
            <a href={PHONE_HREF} data-testid="cta-phone-link" className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-4 text-sm font-bold text-[#050B1F] transition-transform hover:-translate-y-0.5">
              <Phone className="h-4 w-4" /> {PHONE}
            </a>
            <a href={`mailto:${EMAIL}`} data-testid="cta-email-link" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-4 text-sm font-semibold text-white transition-colors hover:border-lime-300 hover:text-lime-300">
              <Mail className="h-4 w-4" /> {EMAIL}
            </a>
          </div>
        </Reveal>
        <div className="flex justify-center py-6 lg:col-span-4">
          <RotatingLogo size={220} testid="cta-rotating-logo" className="scale-75 sm:scale-100" />
        </div>
      </div>
    </div>
  </section>
);
